import React, { useEffect, useState } from "react";
import DateFilter from "./date";
import {isAuthenticated} from '../../../auth/index'
import {getUserInfo, getUsersList, getUsersListV2} from '../../../features/employees/helper/api'
import { addQueryLocalStorage, startLoader, removeGivenQueryLocalStorage,stopLoader } from "../../../lib/utils";
// import config from "../../../config";
import client from "../../../clients";

const FollowUpFilter = (props={
  selectedGym:null,
  handleSetFollowupFilterParams:()=>{
    return {
      assignedTo:'',
      scheduled_type:'',
      dateRange:{
        start:'',
        end:''
      },
      status:'',
      creation_type:''
    }
}
}) => {

  const [status,setStatus] = useState('');
  const [generatedBy,setGeneratedBy]= useState('');
  const [type,setType] = useState("");
  const [membershipType, setMembershipType] = useState("");
  const [currentElementId, setCurrentElementId] = useState("");
  const [assignedUser, setAssignedUser] = useState(false);
  const [userList, setUserList] = useState([]);
  const followUpTypes = ["Balance Due", "Commitment", "Enquiry", "Trial", "Anniversary Wish", "Birthday Wish", "Feedback", "Measurement", "Freeze", "Membership Renewal", "P.T Renewal", "Regular Member", "Irregular Member", "Other"];
  const membershipTypeOptions = ["All Membership", "Gym Workout", "Personal Training", "Group Ex", "Lyberty Membership"];
  const {user,token} = isAuthenticated();
  const [searchData, setSearchData] = useState("");
  const [dateFilter, setDateFilter] = useState("scheduled-date");



  const handleSelectStatus = value =>{
    addQueryLocalStorage("status",value);
    setStatus(value)
  }
  

  const GetUserParams = () =>{
    const params = {
      noLimit:'noLimit',
      branchIDs:props.selectedGym._id,
      isEmployee:true,
    };

    if(searchData){
      params.q = searchData;
    }

    return params;
  }

  const GetAllUser = async () =>{
    try{
      const params = GetUserParams();
      const response = await getUsersListV2(user._id,token,params);
      if(response.error){
      }else{
        setUserList(response)
      }
    }catch(error){

    }
  }


  const toggleInputFields = (id) => {
    if (currentElementId == id) {
      setCurrentElementId('')
    } else {
      setCurrentElementId(id);
    }
  };

  const selectAttendant = (role) => {
    if(role) addQueryLocalStorage("attendant",role._id)
    setAssignedUser(role)
  }

  const selectFollowUpType = (type) => {
    addQueryLocalStorage("type",type);
    setType(type);
    setCurrentElementId('');
    // props.handleSetFollowupFilterParams({
    //   scheduled_type:type
    // })

  }
const formatToReadableMembershipType = (value) => {
  const found = membershipTypeOptions.find(
    opt => opt.trim().split(" ").join("") === value
  );
  return found || value;
}
const selectMembershipType = (value) => {
  if (value === "All Membership") {
    removeGivenQueryLocalStorage(["membership_type"]);
  } else {
    const formattedValue = value.trim().split(" ").join("");
    addQueryLocalStorage("membership_type", formattedValue);
  }
  setMembershipType(value); 
  setCurrentElementId('');
}

  const handleSelectGeneratedBy = (value) =>{
    addQueryLocalStorage("sortby",value);
    setGeneratedBy(value)
  }

  const handleChange = () => event => {
    // alert(event.target.value)
    setSearchData(event.target.value)
  }

  const handleSelectedFilterByDateType = (value) => {
    if(value) addQueryLocalStorage("followup_date_type",value)
    setDateFilter(value);
  }

  useEffect(async ()=>{
    try{
      if(props.selectedGym){
        await startLoader();
        await GetAllUser();
        await stopLoader();
      }
    }catch(error){
      await stopLoader()
    }
  },[props.selectedGym, searchData])


  useEffect(async ()=>{
    try{
      const queryParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(queryParams.entries());

      if(params.status){
        setStatus(params.status)
      }else{
        setStatus("");
      }

      if(params.type){
        setType(params.type)
      }else{
        setType("");
      }

      if(params.membership_type){
       setMembershipType(formatToReadableMembershipType(params.membership_type))
      }else{
      setMembershipType("");
       }

      if(params.sortby){
        setGeneratedBy(params.sortby)
      }else{
        setGeneratedBy("")
      }

      if(params.attendant){
        let response = await getUserInfo(user._id,token,params.attendant);
        setAssignedUser(response)
      }else{
        setAssignedUser("")
      }


    }catch(error){
      console.log(error)
    }
  },[window.location.search]);


  // Reset membership type whenever the follow-up type is no longer "Membership Renewal"
  useEffect(()=>{
    if(type !== "Membership Renewal" && membershipType){
      setMembershipType("");
    }
  },[type]);


  // useEffect(()=>{
  //   try{
  //     let params = {};
  //     if(type) params.scheduled_type = type;
  //     params.dateRange = {...dateRange};
  //     params.status = status;
  //     if(filteBy) params.creation_type = filteBy;
  //     if(assignedToUser) params.assignedTo = assignedToUser;
  //     props.handleSetFollowupFilterParams(params)
  //   }catch(error){

  //   }
  // },[type,dateRange,filteBy,assignedToUser,status])


  if(!props.handleSetFollowupFilterParams){
    return <></>
  }

  return(
    <div className="w-full">
      <p className="fs-16 m-b-6 font-weight-700 color-black">Follow Ups</p>
      <div onClick={()=>toggleInputFields('assigned-user')} className={`${currentElementId == "assigned-user" || assignedUser ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: (currentElementId == "assigned-user" || assignedUser) ? "1px solid var(--darkBlue)" : "", height:"auto", minHeight:"54px" }}>
        <div className="flex-item d-flex" style={{marginTop: (currentElementId == "assigned-user" || assignedUser) ? "4px" : ""}}>
          <svg className="flex-item m-r-4" width={(currentElementId == "assigned-user" || assignedUser) ? "14" : "24"} height={(currentElementId == "assigned-user" || assignedUser) ? "14" : "24"} style={{ transition: "180ms" }} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 4.07143C10.5439 4.07143 11.0756 4.22852 11.5278 4.52285C11.9801 4.81717 12.3325 5.23551 12.5407 5.72496C12.7488 6.2144 12.8033 6.75297 12.6972 7.27256C12.5911 7.79216 12.3291 8.26943 11.9445 8.64404C11.5599 9.01864 11.0699 9.27375 10.5365 9.3771C10.0031 9.48046 9.45012 9.42741 8.94762 9.22468C8.44512 9.02194 8.01563 8.67862 7.71346 8.23813C7.41128 7.79765 7.25 7.27977 7.25 6.75C7.25 6.0396 7.53973 5.35829 8.05546 4.85596C8.57118 4.35363 9.27065 4.07143 10 4.07143ZM10 3C9.23854 3 8.49418 3.21993 7.86105 3.63199C7.22793 4.04404 6.73446 4.62971 6.44306 5.31494C6.15167 6.00016 6.07542 6.75416 6.22398 7.48159C6.37253 8.20902 6.73921 8.8772 7.27764 9.40165C7.81607 9.9261 8.50208 10.2833 9.2489 10.4279C9.99573 10.5726 10.7698 10.4984 11.4733 10.2145C12.1768 9.93072 12.7781 9.45007 13.2012 8.83339C13.6242 8.2167 13.85 7.49168 13.85 6.75C13.85 5.75544 13.4444 4.80161 12.7224 4.09835C12.0003 3.39509 11.0211 3 10 3ZM15.5 18H14.4V15.3214C14.4 14.9697 14.3289 14.6214 14.1907 14.2964C14.0525 13.9714 13.8499 13.6761 13.5945 13.4274C13.3392 13.1787 13.036 12.9814 12.7024 12.8468C12.3687 12.7121 12.0111 12.6429 11.65 12.6429H8.35C7.62065 12.6429 6.92118 12.9251 6.40546 13.4274C5.88973 13.9297 5.6 14.611 5.6 15.3214V18H4.5V15.3214C4.5 14.3269 4.90562 13.373 5.62764 12.6698C6.34965 11.9665 7.32892 11.5714 8.35 11.5714H11.65C12.6711 11.5714 13.6503 11.9665 14.3724 12.6698C15.0944 13.373 15.5 14.3269 15.5 15.3214V18Z" fill={(currentElementId == "assigned-user" || assignedUser) ? "var(--darkBlue)" : "#6d6d6d"}/>
          </svg>
          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "assigned-user" || assignedUser) ? "10px" : "16px", lineHeight: (currentElementId == "assigned-user" || assignedUser) ? "10px" : "16px", color: (currentElementId == "assigned-user" || assignedUser) ? "var(--darkBlue)" : "", transition: "180ms" }}>Select assigned to </p>
        </div>
        <div className='input-field-arrow-dropdown' style={{ margin: "15px 12px 4px 0", transition: "180ms" }}>
          <svg className="flex-item" style={{ transform: currentElementId == "assigned-user" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
          </svg>
        </div>
        {
          assignedUser ? (
            <div className="w-full d-flex m-t-8 m-b-8">
              {/* <div className="enq-attendant-profile d-flex">
                <img className="flex-item w-full h-full margin-auto" src={'https://picsum.photos/id/4/200/300'} />
              </div> */}
              {
                assignedUser.profileID ?
                  <div className='pt-trainer-profile d-flex m-r-8'>
                    <img src={`${client.config.API_URL}/image/file/${assignedUser.profileID}/auto/auto/70`} loading='lazy' className="flex-item" />
                  </div>
                  :
                  <div className="pt-trainer-profile d-flex flex-item m-r-8" style={{backgroundColor:'#5d883c'}}>
                    <p className='flex-item margin-auto' style={{color:'#fff'}}>{`${assignedUser.name}`.trim()[0]}</p>
                  </div>
              }
              <div className="flex-item">
                <p className="font-weight-600 fs-16" style={{lineHeight:"16px"}}>{assignedUser.name}</p>
              </div>
            </div>
          ) : <input id="assigned-user" className={`${(currentElementId == "assigned-user" || assignedUser) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select Trainer" value={assignedUser ? assignedUser : ""} style={{ pointerEvents: "none", textTransform: 'capitalize' }} />
        }
        
        {
          currentElementId == "assigned-user" && (
            <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5", marginTop : assignedUser && "70px"}}>
              <div onClick={e => e.stopPropagation()} className="w-full" style={{padding:"8px", backgroundColor:"#f5f5f5", position:"sticky", top:0}}>
                <div className="search-container d-flex space-between" style={{width:"100%",background:"#ffffff"}}>
                  <div className="d-flex w-full">
                    <svg className="flex-item m-r-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 21L16.657 16.657M16.657 16.657C17.3999 15.9141 17.9892 15.0322 18.3912 14.0615C18.7933 13.0909 19.0002 12.0506 19.0002 11C19.0002 9.9494 18.7933 8.90908 18.3913 7.93845C17.9892 6.96782 17.3999 6.08589 16.657 5.343C15.9141 4.60011 15.0322 4.01082 14.0616 3.60877C13.0909 3.20673 12.0506 2.99979 11 2.99979C9.94942 2.99979 8.90911 3.20673 7.93848 3.60877C6.96785 4.01082 6.08591 4.60011 5.34302 5.343C3.84269 6.84333 2.99982 8.87821 2.99982 11C2.99982 13.1218 3.84269 15.1567 5.34302 16.657C6.84335 18.1573 8.87824 19.0002 11 19.0002C13.1218 19.0002 15.1567 18.1573 16.657 16.657Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <input type="text" placeholder={`Search Employee by “Name“`} onChange={handleChange("search")} value={searchData} className="flex-item search-input" style={{width:"85%"}} />
                  </div>
                </div>
              </div>
              <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                {
                  userList.map((trainer, index) => {
                    return (
                      <div onClick={()=>selectAttendant(trainer)} className="global-input-field-arrow-dropdown-item d-flex">
                        {/* <div className="pt-trainer-profile d-flex m-r-8">
                          <img className="flex-item margin-auto" src={'https://picsum.photos/id/4/200/300'} />
                        </div> */}
                        {
                          trainer.profileID ?
                            <div className='pt-trainer-profile d-flex m-r-8'>
                              <img src={`${client.config.API_URL}/image/file/${trainer.profileID}/auto/auto/70`} loading='lazy' className="flex-item" />
                            </div>
                            :
                            <div className="pt-trainer-profile d-flex flex-item m-r-8" style={{backgroundColor:"#5d883c"}}>
                              <p className='flex-item margin-auto' style={{color:'#fff'}}>{`${trainer.name}`.trim()[0]}</p>
                            </div>
                        }
                        <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{trainer.name}</p>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          )
        }
      </div>
      <div onClick={()=>toggleInputFields('follow-up-type')} className={`${currentElementId == "follow-up-type" || type ? "member-global-input-field m-b-20 flex-item" : "member-global-input-field m-b-20 flex-item d-flex"}`} style={{ border: (currentElementId == "follow-up-type" || type) ? "1px solid var(--darkBlue)" : "", height:"auto", minHeight:"54px" }}>
        <div className="flex-item d-flex" style={{marginTop: (currentElementId == "follow-up-type" || type) ? "4px" : ""}}>
          <svg className="flex-item m-r-4" width={(currentElementId == "follow-up-type" || type) ? "14" : "24"} height={(currentElementId == "follow-up-type" || type) ? "14" : "24"} style={{ transition: "180ms" }} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 4.07143C10.5439 4.07143 11.0756 4.22852 11.5278 4.52285C11.9801 4.81717 12.3325 5.23551 12.5407 5.72496C12.7488 6.2144 12.8033 6.75297 12.6972 7.27256C12.5911 7.79216 12.3291 8.26943 11.9445 8.64404C11.5599 9.01864 11.0699 9.27375 10.5365 9.3771C10.0031 9.48046 9.45012 9.42741 8.94762 9.22468C8.44512 9.02194 8.01563 8.67862 7.71346 8.23813C7.41128 7.79765 7.25 7.27977 7.25 6.75C7.25 6.0396 7.53973 5.35829 8.05546 4.85596C8.57118 4.35363 9.27065 4.07143 10 4.07143ZM10 3C9.23854 3 8.49418 3.21993 7.86105 3.63199C7.22793 4.04404 6.73446 4.62971 6.44306 5.31494C6.15167 6.00016 6.07542 6.75416 6.22398 7.48159C6.37253 8.20902 6.73921 8.8772 7.27764 9.40165C7.81607 9.9261 8.50208 10.2833 9.2489 10.4279C9.99573 10.5726 10.7698 10.4984 11.4733 10.2145C12.1768 9.93072 12.7781 9.45007 13.2012 8.83339C13.6242 8.2167 13.85 7.49168 13.85 6.75C13.85 5.75544 13.4444 4.80161 12.7224 4.09835C12.0003 3.39509 11.0211 3 10 3ZM15.5 18H14.4V15.3214C14.4 14.9697 14.3289 14.6214 14.1907 14.2964C14.0525 13.9714 13.8499 13.6761 13.5945 13.4274C13.3392 13.1787 13.036 12.9814 12.7024 12.8468C12.3687 12.7121 12.0111 12.6429 11.65 12.6429H8.35C7.62065 12.6429 6.92118 12.9251 6.40546 13.4274C5.88973 13.9297 5.6 14.611 5.6 15.3214V18H4.5V15.3214C4.5 14.3269 4.90562 13.373 5.62764 12.6698C6.34965 11.9665 7.32892 11.5714 8.35 11.5714H11.65C12.6711 11.5714 13.6503 11.9665 14.3724 12.6698C15.0944 13.373 15.5 14.3269 15.5 15.3214V18Z" fill={(currentElementId == "follow-up-type" || type) ? "var(--darkBlue)" : "#6d6d6d"}/>
          </svg>
          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "follow-up-type" || type) ? "10px" : "16px", lineHeight: (currentElementId == "follow-up-type" || type) ? "10px" : "16px", color: (currentElementId == "follow-up-type" || type) ? "var(--darkBlue)" : "", transition: "180ms" }}>Type</p>
        </div>
        <div className='input-field-arrow-dropdown' style={{ margin: "15px 12px 4px 0", transition: "180ms" }}>
          <svg className="flex-item" style={{ transform: currentElementId == "follow-up-type" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
          </svg>
        </div>
        {
          type ? (
            <div className="w-full d-flex m-t-8 m-b-8">
              <p className="font-weight-600 fs-16" style={{lineHeight:"16px"}}>{type}</p>
            </div>
          ) : <p id="follow-up-type" className={`${(currentElementId == "follow-up-type" ||type) ? "active-input-field" : "inactive-input-field"} color-grey-06 font-weight-300`}>Select Follow Up Type</p>
         }
        
        {
          currentElementId == "follow-up-type" && (
            <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5", marginTop : type && "70px"}}>
              <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                {
                  followUpTypes.map((type, index) => {
                    return (
                      <div onClick={()=>selectFollowUpType(type)} className="global-input-field-arrow-dropdown-item d-flex">
                        <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{type}</p>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          )
        }
      </div>

      {/*
        Membership Type dropdown — only visible when the follow-up "Type" is "Membership Renewal".
        NOTE: styling/animation is intentionally different from the other dropdowns above
        (.global-input-field-arrow-dropdown + scaleFromTopToBottom). This one uses
        .membership-type-dropdown-panel + .fadeSlideDown (see style.scss).
      */}
      {
        type == "Membership Renewal" && (
          <div
            onClick={()=>toggleInputFields('membership-type')}
            className={`${currentElementId == "membership-type" || membershipType ? "member-global-input-field m-b-20 flex-item" : "member-global-input-field m-b-20 flex-item d-flex"}`}
            style={{ border: (currentElementId == "membership-type" || membershipType) ? "1px solid var(--darkBlue)" : "", height:"auto", minHeight:"54px", position:"relative" }}
          >
            <div className="flex-item d-flex" style={{marginTop: (currentElementId == "membership-type" || membershipType) ? "4px" : ""}}>
              <svg className="flex-item m-r-4" width={(currentElementId == "membership-type" || membershipType) ? "14" : "24"} height={(currentElementId == "membership-type" || membershipType) ? "14" : "24"} style={{ transition: "180ms" }} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 4.07143C10.5439 4.07143 11.0756 4.22852 11.5278 4.52285C11.9801 4.81717 12.3325 5.23551 12.5407 5.72496C12.7488 6.2144 12.8033 6.75297 12.6972 7.27256C12.5911 7.79216 12.3291 8.26943 11.9445 8.64404C11.5599 9.01864 11.0699 9.27375 10.5365 9.3771C10.0031 9.48046 9.45012 9.42741 8.94762 9.22468C8.44512 9.02194 8.01563 8.67862 7.71346 8.23813C7.41128 7.79765 7.25 7.27977 7.25 6.75C7.25 6.0396 7.53973 5.35829 8.05546 4.85596C8.57118 4.35363 9.27065 4.07143 10 4.07143ZM10 3C9.23854 3 8.49418 3.21993 7.86105 3.63199C7.22793 4.04404 6.73446 4.62971 6.44306 5.31494C6.15167 6.00016 6.07542 6.75416 6.22398 7.48159C6.37253 8.20902 6.73921 8.8772 7.27764 9.40165C7.81607 9.9261 8.50208 10.2833 9.2489 10.4279C9.99573 10.5726 10.7698 10.4984 11.4733 10.2145C12.1768 9.93072 12.7781 9.45007 13.2012 8.83339C13.6242 8.2167 13.85 7.49168 13.85 6.75C13.85 5.75544 13.4444 4.80161 12.7224 4.09835C12.0003 3.39509 11.0211 3 10 3ZM15.5 18H14.4V15.3214C14.4 14.9697 14.3289 14.6214 14.1907 14.2964C14.0525 13.9714 13.8499 13.6761 13.5945 13.4274C13.3392 13.1787 13.036 12.9814 12.7024 12.8468C12.3687 12.7121 12.0111 12.6429 11.65 12.6429H8.35C7.62065 12.6429 6.92118 12.9251 6.40546 13.4274C5.88973 13.9297 5.6 14.611 5.6 15.3214V18H4.5V15.3214C4.5 14.3269 4.90562 13.373 5.62764 12.6698C6.34965 11.9665 7.32892 11.5714 8.35 11.5714H11.65C12.6711 11.5714 13.6503 11.9665 14.3724 12.6698C15.0944 13.373 15.5 14.3269 15.5 15.3214V18Z" fill={(currentElementId == "membership-type" || membershipType) ? "var(--darkBlue)" : "#6d6d6d"}/>
              </svg>
              <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "membership-type" || membershipType) ? "10px" : "16px", lineHeight: (currentElementId == "membership-type" || membershipType) ? "10px" : "16px", color: (currentElementId == "membership-type" || membershipType) ? "var(--darkBlue)" : "", transition: "180ms" }}>Membership Type</p>
            </div>
            <div className='input-field-arrow-dropdown' style={{ margin: "15px 12px 4px 0", transition: "180ms" }}>
              <svg className="flex-item" style={{ transform: currentElementId == "membership-type" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
              </svg>
            </div>

            {
              membershipType ? (
                <div className="w-full d-flex m-t-8 m-b-8">
                  <p className="font-weight-600 fs-16" style={{lineHeight:"16px"}}>{membershipType}</p>
                </div>
              ) : <p id="membership-type" className={`${(currentElementId == "membership-type" || membershipType) ? "active-input-field" : "inactive-input-field"} color-grey-06 font-weight-300`}>Select Membership Type</p>
            }

            {
              currentElementId == "membership-type" && (
                <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 fadeSlideDown" style={{background:"#f5f5f5", border: "1px solid #f5f5f5", marginTop : membershipType && "70px"}}>
                  <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                 {
                     membershipTypeOptions.map((option, index) => (
                   <div key={index} onClick={()=>selectMembershipType(option)} className={`global-input-field-arrow-dropdown-item d-flex ${membershipType == option ? "global-input-field-arrow-dropdown-item-active" : ""}`}>
                   <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{option}</p>
                    </div>
                   ))
                   }
                  </div>
                </div>
              )
            }
          </div>
        )
      }

      {
        type == "Membership Renewal" && (
          <div className="w-full m-b-20">
            <p className="fs-16 m-b-6 font-weight-700 color-black">Convertibility</p>
            <div className="d-flex space-between">
              <div className="d-flex">
                <input type="radio" style={{width:"16px", height:'16px'}} className="flex-item m-r-8" />
                <svg className="flex-item m-r-6" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.42383 9.20312H12.1361M7.42383 11.0539H12.1361M9.44306 9.20312C9.8919 9.31505 10.7896 9.70851 10.7896 10.8854C10.7896 12.9047 8.09652 12.9047 8.09652 12.9047C8.09652 12.9047 9.44306 14.0827 11.4623 14.5881" stroke="#DF2B03" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9.7805 17.8574C13.819 17.8574 16.7036 16.429 16.7036 13.249C16.7036 9.79319 14.9728 7.48896 11.5113 5.7605L12.8728 4.00896C12.9422 3.89407 12.9798 3.76285 12.9819 3.62867C12.9841 3.49449 12.9506 3.36215 12.8849 3.24511C12.8192 3.12808 12.7237 3.03055 12.6081 2.96245C12.4925 2.89434 12.3608 2.8581 12.2267 2.85742H7.33435C7.20043 2.85881 7.06926 2.89549 6.95405 2.96376C6.83884 3.03203 6.74367 3.12947 6.67813 3.24626C6.6126 3.36305 6.57902 3.49505 6.58079 3.62896C6.58256 3.76287 6.6196 3.89394 6.68819 4.00896L8.04973 5.77204C4.58819 7.51204 2.85742 9.81627 2.85742 13.272C2.85742 16.429 5.74204 17.8574 9.7805 17.8574Z" stroke="#DF2B03" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p className="flex-item font-weight-600">Hot</p>
              </div>

              <div className="d-flex">
                <input type="radio" style={{width:"16px", height:'16px'}} className="flex-item m-r-8" />
                <svg className="flex-item m-r-6" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.42383 9.20312H12.1361M7.42383 11.0539H12.1361M9.44306 9.20312C9.8919 9.31505 10.7896 9.70851 10.7896 10.8854C10.7896 12.9047 8.09652 12.9047 8.09652 12.9047C8.09652 12.9047 9.44306 14.0827 11.4623 14.5881" stroke="#DD9F00" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9.7805 17.8574C13.819 17.8574 16.7036 16.429 16.7036 13.249C16.7036 9.79319 14.9728 7.48896 11.5113 5.7605L12.8728 4.00896C12.9422 3.89407 12.9798 3.76285 12.9819 3.62867C12.9841 3.49449 12.9506 3.36215 12.8849 3.24511C12.8192 3.12808 12.7237 3.03055 12.6081 2.96245C12.4925 2.89434 12.3608 2.8581 12.2267 2.85742H7.33435C7.20043 2.85881 7.06926 2.89549 6.95405 2.96376C6.83884 3.03203 6.74367 3.12947 6.67813 3.24626C6.6126 3.36305 6.57902 3.49505 6.58079 3.62896C6.58256 3.76287 6.6196 3.89394 6.68819 4.00896L8.04973 5.77204C4.58819 7.51204 2.85742 9.81627 2.85742 13.272C2.85742 16.429 5.74204 17.8574 9.7805 17.8574Z" stroke="#DD9F00" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p className="flex-item font-weight-600">Warm</p>
              </div>

              <div className="d-flex">
                <input type="radio" style={{width:"16px", height:'16px'}} className="flex-item m-r-8" />
                <svg className="flex-item m-r-6" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.42383 9.20312H12.1361M7.42383 11.0539H12.1361M9.44306 9.20312C9.8919 9.31505 10.7896 9.70851 10.7896 10.8854C10.7896 12.9047 8.09652 12.9047 8.09652 12.9047C8.09652 12.9047 9.44306 14.0827 11.4623 14.5881" stroke="#0088DA" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9.7805 17.8574C13.819 17.8574 16.7036 16.429 16.7036 13.249C16.7036 9.79319 14.9728 7.48896 11.5113 5.7605L12.8728 4.00896C12.9422 3.89407 12.9798 3.76285 12.9819 3.62867C12.9841 3.49449 12.9506 3.36215 12.8849 3.24511C12.8192 3.12808 12.7237 3.03055 12.6081 2.96245C12.4925 2.89434 12.3608 2.8581 12.2267 2.85742H7.33435C7.20043 2.85881 7.06926 2.89549 6.95405 2.96376C6.83884 3.03203 6.74367 3.12947 6.67813 3.24626C6.6126 3.36305 6.57902 3.49505 6.58079 3.62896C6.58256 3.76287 6.6196 3.89394 6.68819 4.00896L8.04973 5.77204C4.58819 7.51204 2.85742 9.81627 2.85742 13.272C2.85742 16.429 5.74204 17.8574 9.7805 17.8574Z" stroke="#0088DA" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p className="flex-item font-weight-600">Cold</p>
              </div>
            </div>
          </div>
        )
      }

      <div className="d-flex m-t-8 m-b-6">
        <div onClick={()=>handleSelectedFilterByDateType("scheduled-date")} className="flex-item d-flex m-r-16">
          <input className="flex-item m-r-8" style={{width:"16px", height:"16px"}} type="radio" checked={dateFilter=="scheduled-date"} />
          <p className="fs-16 font-weight-700 color-black flex-item" style={{color:dateFilter=="scheduled-date" && "#E33A34"}}>Scheduled Date</p>
        </div>
        <div onClick={()=>handleSelectedFilterByDateType("creation-date")} className="flex-item d-flex">
          <input className="flex-item m-r-8" style={{width:"16px", height:"16px"}} type="radio" checked={dateFilter=="creation-date"}/>
          <p className="fs-16 font-weight-700 color-black flex-item" style={{color:dateFilter=="creation-date" && "#E33A34"}}>Creation Date</p>
        </div>
      </div>

      <DateFilter header={"invisible"}/>

      <div className="w-full m-b-20">
        <p className="fs-16 m-b-6 font-weight-700 color-black">Status</p>
        <div className="d-flex">

          <div className="d-flex m-r-30" onClick={()=>handleSelectStatus("pending")}>
            <input name="status" type="radio" style={{width:"16px", height:'16px'}} checked={status=="pending"} className="flex-item m-r-8" />
            <p className="flex-item font-weight-600 m-r-6">Pending</p>
            <svg className="flex-item" width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="10" fill="#EF9610"/>
              <g clip-path="url(#clip0_0_1)">
              <path d="M10 6.0625C10 5.94647 9.9539 5.83518 9.87186 5.75314C9.78982 5.6711 9.67853 5.625 9.5625 5.625C9.44647 5.625 9.33518 5.6711 9.25314 5.75314C9.1711 5.83518 9.125 5.94647 9.125 6.0625V10.875C9.12503 10.9521 9.14543 11.0279 9.18416 11.0945C9.22288 11.1612 9.27854 11.2165 9.3455 11.2548L12.408 13.0048C12.5085 13.0591 12.6262 13.072 12.7361 13.0405C12.8459 13.0092 12.9392 12.9361 12.9958 12.8369C13.0525 12.7377 13.0682 12.6203 13.0394 12.5098C13.0107 12.3992 12.9398 12.3042 12.842 12.2452L10 10.6213V6.0625Z" fill="white"/>
              <path d="M10 17C11.8565 17 13.637 16.2625 14.9498 14.9498C16.2625 13.637 17 11.8565 17 10C17 8.14349 16.2625 6.36301 14.9498 5.05026C13.637 3.7375 11.8565 3 10 3C8.14349 3 6.36301 3.7375 5.05026 5.05026C3.7375 6.36301 3 8.14349 3 10C3 11.8565 3.7375 13.637 5.05026 14.9498C6.36301 16.2625 8.14349 17 10 17ZM16.125 10C16.125 11.6245 15.4797 13.1824 14.331 14.331C13.1824 15.4797 11.6245 16.125 10 16.125C8.37554 16.125 6.81763 15.4797 5.66897 14.331C4.52031 13.1824 3.875 11.6245 3.875 10C3.875 8.37554 4.52031 6.81763 5.66897 5.66897C6.81763 4.52031 8.37554 3.875 10 3.875C11.6245 3.875 13.1824 4.52031 14.331 5.66897C15.4797 6.81763 16.125 8.37554 16.125 10Z" fill="white"/>
              </g>
              <defs>
              <clipPath id="clip0_0_1">
              <rect width="14" height="14" fill="white" transform="translate(3 3)"/>
              </clipPath>
              </defs>
            </svg>                  
          </div>

          <div className="d-flex m-r-30" onClick={()=>handleSelectStatus("missed")}>
            <input name="status" type="radio" style={{width:"16px", height:'16px'}} checked={status=="missed"} className="flex-item m-r-8" />
            <p className="flex-item font-weight-600 m-r-6">Missed</p>
            <svg className="flex-item" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="8" cy="8" r="8" fill="#E33A34"/>
              <path d="M4.47852 11.7917L11.5202 4.75M11.5202 11.7917L4.47852 4.75" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>

          <div className="d-flex m-r-30" onClick={()=>handleSelectStatus("done")}>
            <input name="status" type="radio" style={{width:"16px", height:'16px'}} checked={status=="done"} className="flex-item m-r-8" />
            <p className="flex-item font-weight-600 m-r-6">Done</p>
            <svg className="flex-item" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="8" cy="8" r="8" fill="#5D883C"/>
              <path d="M3 8.26667L6.33333 12L13 5" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </div>


        </div>
      </div>

      <div className="w-full m-b-20">
        <p className="fs-16 m-b-6 font-weight-700 color-black">Generated By</p>
        <div className="d-flex">
          <div className="d-flex m-r-28" onClick={()=>handleSelectGeneratedBy("system")}>
            <input name="creation_type" type="radio" style={{width:"16px", height:'16px'}} checked={generatedBy == "system"} className="flex-item m-r-8" />
            <p className="flex-item font-weight-600">System</p>
          </div>

          <div className="d-flex" onClick={()=>handleSelectGeneratedBy("user")}>
            <input name="creation_type" type="radio" style={{width:"16px", height:'16px'}} checked={generatedBy == "user"} className="flex-item m-r-8" />
            <p className="flex-item font-weight-600">User</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FollowUpFilter;